/// <amd-module name="Wit/WorkItemForm/History/Diffs/FieldDiff" />
import * as React from "react";
import { WorkItemFieldUpdate } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { FieldName, FieldValue } from "../../Common/Components";

export interface IFieldDiffProps {
    refName: string;
    fieldUpdate: WorkItemFieldUpdate;
}

export function FieldDiff({ refName, fieldUpdate }: IFieldDiffProps) {
    let addedValue: unknown = fieldUpdate.newValue;
    let removedValue: unknown = fieldUpdate.oldValue;

    if (refName === CoreFieldRefNames.Tags) {
        // Specifically for tags, only show tags which were added or removed
        const oldTags = fieldUpdate.oldValue && typeof fieldUpdate.oldValue === "string" ? fieldUpdate.oldValue.split(";").map(t => t.trim()) : [];
        const newTags = fieldUpdate.newValue && typeof fieldUpdate.newValue === "string" ? fieldUpdate.newValue.split(";").map(t => t.trim()) : [];

        const removedTags = oldTags.filter(t => !newTags.includes(t));
        const addedTags = newTags.filter(t => !oldTags.includes(t));

        addedValue = addedTags.join(";") || null; // Coerce empty strings to null so that we don't show an empty pill when there are no tags
        removedValue = removedTags.join(";") || null;
    }

    const added =
        addedValue !== null && addedValue !== undefined ? (
            <div className="added padding-vertical-4 padding-horizontal-8 margin-horizontal-4 margin-bottom-4">
                <ins>
                    <FieldValue refName={refName} fieldValue={addedValue} />
                </ins>
            </div>
        ) : null;

    const removed =
        removedValue !== null && removedValue !== undefined ? (
            <div className="removed padding-vertical-4 padding-horizontal-8 margin-horizontal-4 margin-bottom-4">
                <del>
                    <FieldValue refName={refName} fieldValue={removedValue} />
                </del>
            </div>
        ) : null;

    return (
        <div className="field-diff flex-row padding-vertical-4">
            <div className="field-name flex-noshrink">
                <FieldName refName={refName} />
            </div>
            <div className="flex-row flex-wrap flex-shrink field-value-diff">
                {added}
                {removed}
            </div>
        </div>
    );
}
